import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormlyOptionToRecordPipe,
  SelectAutocompleteComponent,
} from './select-autocomplete.component';
import { FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { MatPseudoCheckboxModule } from '@angular/material/core';
import { NbButtonModule } from '@nebular/theme';

export const FormFieldSelectAutocomplete = 'select-autocomplete';

@NgModule({
  declarations: [SelectAutocompleteComponent, FormlyOptionToRecordPipe],
  imports: [
    CommonModule,
    FormlyModule.forChild({
      types: [
        {
          name: FormFieldSelectAutocomplete,
          component: SelectAutocompleteComponent,
          wrappers: ['form-field'],
        },
      ],
    }),
    FormlySelectModule,
    NgxMatSelectSearchModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatPseudoCheckboxModule,
    NbButtonModule,
  ],
})
export class FormFieldsSelectAutocompleteModule {}
